import { IFeatureToggle } from 'interfaces/featureToggle';

const loadingFeatures: Partial<IFeatureToggle>[] = [
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'one',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'two',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'three',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'four',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'five',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'six',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'seven',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'eight',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'nine',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'ten',
        project: 'default',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
];

export default loadingFeatures;
